import { render, staticRenderFns } from "./TrackingHistoryTable.vue?vue&type=template&id=cf742a96&scoped=true&"
import script from "./TrackingHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TrackingHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./TrackingHistoryTable.vue?vue&type=style&index=0&id=cf742a96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf742a96",
  null
  
)

export default component.exports